export const PauseSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" fill="white" />
    <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" stroke="#DDE3F2" />
    <rect x="10.5" y="10" width="2" height="8" rx="1" fill="#7587A5" />
    <rect x="15.5" y="10" width="2" height="8" rx="1" fill="#7587A5" />
  </svg>
)
